import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { UpdateProfileForm } from "@/pages/gate/UpdateProfilePage.tsx";

import { IconProfileContentLanguage, IconProfileLanguage, IconProfileRecommendations } from "@/components/icons";

import { useGetSelectedRecommendations } from "../api/content.hooks";

export enum EditOption {
  PIN_CODE,
  INTERFACE_LANG,
  CONTENT_LANG,
  RECOMMENDATIONS,
}

export const useProfileEditOptions = () => {
  const { watch } = useFormContext<UpdateProfileForm>();
  const interfaceLang = watch("interface_lang") as "uz" | "ru" | "en";
  const { getValues } = useFormContext<UpdateProfileForm>();
  const { t } = useTranslation();
  const params = useParams() as { id: string };

  const { content_all, content_ru, content_uz } = getValues();

  const { data } = useGetSelectedRecommendations(+params.id);

  const contentLangDescription = content_all
    ? t("General.all")
    : `${content_ru ? t("language-ru") : ""}${content_uz ? t("language-uz") : ""}`;

  const interfaceLangValue = {
    uz: t("language-uz"),
    ru: t("language-ru"),
    en: t("language-en"),
  };

  const selectedRec = data.map((item) => item.title).join(", ");

  return [
    {
      id: 2,
      type: EditOption.INTERFACE_LANG,
      Icon: IconProfileLanguage,
      title: t("Profile.profile-language"),
      description: interfaceLangValue[interfaceLang],
    },
    {
      id: 3,
      type: EditOption.CONTENT_LANG,
      Icon: IconProfileContentLanguage,
      title: t("Profile.content-language"),
      description: contentLangDescription,
    },
    {
      id: 4,
      type: EditOption.RECOMMENDATIONS,
      Icon: IconProfileRecommendations,
      title: t("General.recommendation", { count: 2 }),
      description: selectedRec ?? t("Profile.choose-movies-or-serials"),
    },
  ];
};
